import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';

const ContactForm = () => {
  const form = useRef();

  const royalBlue = '#002366';
  const softGold = '#d4af37';
  const background = '#f8faff';

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_vu67e47',
        'template_b1nhjrg',
        form.current,
        'xZu2JS9UXrWpCZX-j'
      )
      .then(() => {
        alert('Message sent successfully!');
        form.current.reset();
      }, (error) => {
        alert('Failed to send: ' + error.text);
      });
  };

  return (
    <section
      style={{
        minHeight: '100vh',
        width: '100vw',
        padding: '40px 5vw',
        backgroundColor: background,
        fontFamily: 'Times New Roman, serif',
        boxSizing: 'border-box',
      }}
    >
      <h2
        style={{
          textAlign: 'center',
          fontSize: '2rem',
          color: royalBlue,
          fontWeight: 'bold',
          marginBottom: '30px',
        }}
      >
        CONTACT US
      </h2>

      <form
        ref={form}
        onSubmit={sendEmail}
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
          fontSize: '1rem',
        }}
      >
        {['name', 'email', 'phone'].map((field, idx) => (
          <input
            key={idx}
            type={field === 'email' ? 'email' : field === 'phone' ? 'tel' : 'text'}
            name={field}
            placeholder={
              field === 'name'
                ? 'Your Name'
                : field === 'email'
                ? 'Your Email'
                : 'Your Phone Number (optional)'
            }
            required={field !== 'phone'}
            style={{
              padding: '12px',
              border: `1.5px solid ${royalBlue}`,
              borderRadius: '6px',
              outlineColor: softGold,
            }}
          />
        ))}

        <textarea
          name="message"
          rows="5"
          placeholder="Your Message"
          required
          style={{
            padding: '12px',
            border: `1.5px solid ${royalBlue}`,
            borderRadius: '6px',
            outlineColor: softGold,
          }}
        ></textarea>

        <button
          type="submit"
          style={{
            padding: '14px',
            fontSize: '1.1rem',
            backgroundColor: royalBlue,
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            fontWeight: 'bold',
            cursor: 'pointer',
            letterSpacing: '0.5px',
          }}
          onMouseOver={(e) => (e.target.style.backgroundColor = softGold)}
          onMouseOut={(e) => (e.target.style.backgroundColor = royalBlue)}
        >
          Send Message
        </button>
      </form>

      {/* Contact Info */}
      <div
        style={{
          marginTop: '40px',
          textAlign: 'center',
          fontSize: '1.2rem',
          color: '#333',
        }}
      >
        <p>
          <strong>Call us:</strong>{' '}
          <span style={{ color: royalBlue }}>+91-9551566999</span>
        </p>
        <p>
          <strong>Email:</strong>{' '}
          <span style={{ color: royalBlue }}>sbksthapathi6@gmail.com</span>
        </p>
      </div>
    </section>
  );
};

export default ContactForm;





